export const MAX_TOKEN_BYTES = 4096

export const byteLength = (value: string) =>
  typeof TextEncoder !== 'undefined'
    ? new TextEncoder().encode(value).length
    : Buffer.byteLength(value, 'utf8')